module Meevo.Components.Controls {
    "use strict";

    export class MeevoSmartCenterMaintenanceForm implements angular.IDirective {

        restrict = "E";
        scope = {
            context: "=",
            searchContext: "=",
            shortCutGroup: "=",
            headerContentKey: "@",
            visualState: "=",
            selectedItemId: "=",
            initialEditSection: "=",
            disableCrud: "=",
            hideSearch: "=",
            showCoBar: "=?",
            closeInterceptor: "&?",
            customButtonsSet: "=?",
            customFooterInfo: "=?",
            templateUrl: "@?"
        };

        //isSearchGlobal: "=",

        templateUrl = (elem, attrs) => {
            return attrs.templateUrl || 'app/components/controls/smartCenterMaintenanceFormTemplate.html';
        };

        require = '^form';

        link = (scope: any, element: angular.IAugmentedJQuery, attributes: angular.IAttributes, formCtrl: any) => {
            // Can override template
            if (!_.isUndefined(scope.templateUrl)) {
                scope.templateUrl = 'app/components/controls/smartCenterMaintenanceFormTemplate.html';
            }

            // data maintenance form for searchable entity
            if (_.isUndefined(scope.showCoBar))
                scope.showCoBar = true;
            // Exposes compiled handlebars template
            scope.applySearchResultTemplate = (item: any): string => {
                if (scope.context && scope.context.searchResultTemplateFunction) {
                    return scope.context.searchResultTemplateFunction(item);
                } else {
                    return "";
                }
            }

            // non-searchable data maintenance form will not support quick dropdown results
            scope.showMobileMenu = () => {
                if (!scope.mobileMenu) {
                    scope.mobileMenu = true;
                } else {
                    scope.mobileMenu = false;
                }
            }

            //scope.checkHasLocal = (): boolean => {

            //    let tempLocalActivity = _.find(scope.searchContext, function (item: any) {
            //        return scope.selectedItemId === item.id
            //    });
            //    if (scope.isSearchGlobal) {
            //        return tempLocalActivity.hasLocalProfile;
            //    }
            //    else {
            //        return;
            //    }

            //}

            scope.submitForm = (): void => {
                angular.forEach(formCtrl, function (value, key) {
                    if (typeof value === 'object' && key !== undefined && value.hasOwnProperty('$modelValue'))
                        formCtrl[key].$dirty = true;
                });

                if (formCtrl.$valid && !formCtrl.$pending) {
                    this.busyService.start();
                    scope.context.save().finally(() => {
                        //scope.context.trackingService.saveTrackingInfo();
                        this.busyService.stop();
                    });
                }
                else if (!formCtrl.$valid) {
                    angular.element(".meevo-maint-center").scrollTop(angular.element("[name='maintenanceForm']").find(".ng-invalid")[0].offsetTop);
                }
            }

            scope.cancel = (): void => {
                scope.context.cancel();
                formCtrl.$setPristine();
            }

            scope.detail = (id: Guid): void => {
                scope.selectedItemId = id;
                // Need to clear this out in case user wants to search from the same context. FOR CLIENT CONTEXT
                if (scope.initialEditSection)
                    scope.initialEditSection = undefined;
                scope.visualState = Model.MaintenanceFormVisualState.Detail;
            }

            scope.search = (): void => {
                if (angular.isUndefined(scope.closeInterceptor)) {
                    doSearch();
                } else {
                    scope.closeInterceptor()
                        .then(() => {
                            doSearch();
                        })
                }

            }

            scope.closeContext = (): void => {
                if (angular.isUndefined(scope.closeInterceptor)) {
                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
                } else {
                    scope.closeInterceptor()
                        .then(() => {
                            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
                        })
                }
            }

            function doSearch() {
                scope.selectedItemId = null;
                scope.visualState = Model.MaintenanceFormVisualState.Search;

                if (scope.context.selectedSection != null && scope.context.selectedSection.model != null)
                    scope.context.selectedSection.model = null;
            }

            scope.$watch(() => {
                return formCtrl.$error;
            }, (newVal) => {
                scope.validationErrorList = newVal;
            }, true)


            if(scope.shortCutGroup) {
                this.shortCutsService.maintenanceFormDirectiveWrapper(scope);
            }

        }

        constructor(private $rootScope: angular.IRootScopeService,
            private $state: angular.ui.IStateService,
            private $document: angular.IDocumentService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService) {

        }


        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope: angular.IRootScopeService, $state: angular.ui.IStateService,
                $document: angular.IDocumentService, busyService: Meevo.Components.Busy.IBusyService,
                shortCutsService: Meevo.Components.ShortCuts.IShortCutsService) => {
                return new MeevoSmartCenterMaintenanceForm($rootScope, $state, $document, busyService, shortCutsService);
            };

            directive.$inject = ["$rootScope", "$state", "$document", "meevo.components.busy.BusyService",
            'meevo.components.short-cuts.ShortCutsService'];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoSmartCenterMaintenanceForm", MeevoSmartCenterMaintenanceForm.factory());
}